import React, { useEffect, useState } from "react";
import Footer from "./Footer";
import axiosStrapiInstance, { baseUrl } from "../axiosStrapi";
import { GoArrowRight } from "react-icons/go";
import GetInTouchFooter from "./GetInTouchFooter";
import { MapContainer, TileLayer, Marker, Popup, useMap } from "react-leaflet";
import L from "leaflet";
import "leaflet/dist/leaflet.css";
import locationLogo from "../assets/Motherspride.png";
import { RiArrowDropDownLine } from "react-icons/ri";
import { RiArrowDropUpLine } from "react-icons/ri";
import ReactMarkdown from "react-markdown";
import CustomHeading from "./custom/CustomHeading";
import CustomContent from "./custom/CustomContent";
import { Helmet } from "react-helmet";

const OurBranch = () => {
  const [branches, setBranches] = useState([]);
  const [selectedBranch, setSelectedBranch] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");
  const [sortFilter, setSortFilter] = useState("");
  const [openAbout, setOpenAbout] = useState(null);

  const [debouncedTerm, setDebouncedTerm] = useState("");
  useEffect(() => {
    window.scrollTo(0, 20);
  }, []);

  // Use Map hook to programmatically update the map
  const UpdateMap = () => {
    const map = useMap();

    useEffect(() => {
      if (selectedBranch) {
        // Move the map to the selected branch
        map.flyTo([selectedBranch?.lat, selectedBranch?.long], 14);
      }
    }, [selectedBranch, map]);

    return null;
  };

  useEffect(() => {
    const timer = setTimeout(() => {
      setDebouncedTerm(searchTerm);
    }, 1000);
    return () => clearTimeout(timer);
  }, [searchTerm]);

  const handleSearch = async (searchTerm) => {
    try {
      const params = new URLSearchParams();

      // Add search filter only if searchTerm is provided
      if (searchTerm) {
        params.append("filters[address][$containsi]", searchTerm);
      }

      // Add sort field only if provided
      if (sortFilter) {
        params.append("sort", `${sortFilter}:${"asc"}`); // Default to ascending
      }

      const response = await axiosStrapiInstance.get(
        `/api/branches?${params.toString()}`
      );
      setBranches(response?.data?.data || []);
    } catch (error) {
      console.error("Error fetching data from Strapi:", error);
    }
  };

  useEffect(() => {
    if (debouncedTerm) {
      handleSearch(debouncedTerm);
    } else {
      handleSearch("");
    }
  }, [debouncedTerm]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axiosStrapiInstance.get(
          "/api/branches?populate=*&sort=branch_id:asc"
        );
        setBranches(response?.data?.data || []);
      } catch (error) {
        console.error("Error fetching data from Strapi:", error);
      }
    };
    fetchData();
  }, []);

  const handleReadMore = (e, id) => {
    e.stopPropagation();
    if (id === openAbout) {
      setOpenAbout(null);
    } else {
      setOpenAbout(id);
    }
  };

  return (
    <div>
      <Helmet>
        <title>Find a Mother's Pride Preschool Near You – Branches Across Delhi</title>
          <link rel="canonical" href="https://www.motherspridepreschool.com/branch" />
        <meta name="description" content="Mother's Pride Preschool branches across India, including Delhi, Gurugram, Noida, Faridabad, and more. Locate your nearest center and join India's most loved preschool for holistic early childhood education." />
        <meta name="keywords" content="Mother's Pride branches, Preschool admissions near me, Find a preschool nearby" />
      </Helmet>
      <div style={styles.container}>
        <main>
          <CustomHeading
            text={"Our "}
            spanText={"Branches"}
            textColor="#121212"
            spanTextColor="#d31c4f"
            textSize="48px"
            smTextSize="36px"
            leading="60px"
          />

          <p
            style={styles.subtitle}
            className="font-bold text-[#121212] leading-9 font-Lato text-2xl sm:text-3xl mt-2 sm:mt-4"
          >
            Nearby Branches
          </p>

          {/* Search */}
          <div className="flex justify-between gap-3 lg:w-[48%] mb-[30px] ">
            <input
              type="text"
              placeholder="Search by city name"
              className="p-1 sm:p-2 text-base rounded-lg border border-[#e8e8e8] outline-none min-w-[50%] sm:min-w-[72%] text-[#383838]"
              onChange={(e) => setSearchTerm(e?.target?.value)}
            />
            <select
              className="p-2 text-base rounded-lg border border-[#E8E8E8] outline-none text-[#383838] min-w-[38%] sm:min-w-[25%]"
              onChange={(e) => {
                //todo :-> handleSearch();
                setSortFilter(e.target.value)
              }}
            >
              <option value="">Sort By</option>
              <option value="name">Name</option>
              {/* <option value="city">City</option> */}
            </select>
          </div>

          {/* Branch List and Map */}
          <div className="flex lg:flex-row flex-col flex-wrap space-between gap-6">
            <div
              style={{
                boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
              }}
              className="lg:w-[48%] rounded-[20px] h-[400px] cursor-pointer scrollbar-hidden overflow-y-scroll"
            >
              {branches.map((branch, index) => (
                <div
                  key={index}
                  style={styles.branchCard}
                  onClick={() => setSelectedBranch(branch)}
                >
                  <h3 style={styles.branchTitle}>
                    Mother's Pride,{branch?.name}
                  </h3>
                  <p style={styles.branchText}>{branch.address}</p>
                  <p style={styles.branchText}>
                    📞 {branch?.phone1} {branch.phone2 && `, ${branch?.phone2}`}{" "}
                  </p>
                  <button
                    className="text-[#d31c4f] font-Lato"
                    onClick={(e) => handleReadMore(e, branch.id)}
                  >
                    Read More{" "}
                    {openAbout === branch?.id ? (
                      <RiArrowDropUpLine className="inline text-4xl ml-[-8px]" />
                    ) : (
                      <RiArrowDropDownLine className="inline text-4xl ml-[-8px]" />
                    )}
                  </button>
                  {openAbout === branch?.id && (
                    <div>
                      {branch?.about && (
                        <p className="font-bold my-2  mt-0 text-xl sm:text-[28px] leading-10 ">
                          About Us
                        </p>
                      )}
                      <p>{branch?.about}</p>
                      <div className="sm:grid-cols-2 mt-7 grid-cols-1 gap-4  grid">
                        {branch?.images?.map((item, index) => (
                          <img
                            src={`${item?.url}`}
                            className="h-[200px] rounded-xl w-[300px]"
                            alt={`image-${index}`}
                          />
                        ))}
                      </div>
                      <ReactMarkdown className="blogMarkdown mt-5 font-Lato">
                        {branch?.feedBack}
                      </ReactMarkdown>
                    </div>
                  )}
                </div>
              ))}
            </div>
            <div
              style={{ boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)" }}
              className="lg:w-[48%] h-[400px] z-10 rounded-lg overflow-hidden"
            >
              {/* Embedded Google Map */}
              {/* <iframe
              src={`https://www.google.com/maps?q=${selectedBranch?.lat},${selectedBranch?.long}&hl=es;z=14&output=embed`}
              width="100%"
              height="100%"
              style={{ border: "0" }}
              allowFullScreen=""
              loading="lazy"
              title="Google Map"
            ></iframe> */}

              <MapContainer
                center={[20.5937, 78.9629]} // Center map on India
                zoom={5} // Initial zoom level
                style={{ width: "100%", height: "100%" }}
              >
                <TileLayer
                  url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                  attribution=""
                />
                {/* Loop through branches to add all markers */}
                {branches?.map((branch, index) => (
                  <Marker
                    key={index}
                    position={[branch.lat, branch.long]}
                    icon={L.icon({
                      iconUrl: locationLogo, // Use the imported image here
                      iconSize: [40, 40], // Size of the marker icon
                    })}
                    className="bg-white px-[2%] py-[2%]"
                  >
                    <Popup>
                      <>
                        <p className="font-bold  text-[#dc314f] text-lg">
                          Mother's Pride ,{branch?.name}
                        </p>
                        <p className="mt-[-20px] text-gray-600">
                          {branch?.address}
                        </p>
                      </>
                    </Popup>
                  </Marker>
                ))}
                <UpdateMap />
              </MapContainer>
            </div>
          </div>
        </main>

        <GetInTouchFooter marginX={"0%"} />

        {/* Footer */}
        <Footer marginX={"0%"} />
      </div>
    </div>
  );
};

export default OurBranch;

const styles = {
  container: {
    padding: "4% 4%",
    backgroundColor: "#f9fafb",
  },
  header: {
    backgroundColor: "white",
    boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
    padding: "16px 24px",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },
  nav: {
    display: "flex",
    gap: "16px",
  },
  navLink: {
    color: "#4b5563",
    textDecoration: "none",
    fontWeight: "bold",
  },
  loginButton: {
    backgroundColor: "#60a5fa",
    color: "white",
    padding: "8px 16px",
    borderRadius: "8px",
    border: "none",
    cursor: "pointer",
  },
  title: {
    fontWeight: "bold",
    color: "#000000",
    marginBottom: "8px",
  },
  subtitle: {
    color: "#000000",
    marginBottom: "24px",
  },
  sortInput: {
    padding: "8px",
    fontSize: "16px",
    borderRadius: "8px",
    border: "1px solid #E8E8E8",
    flex: "1",
    outline: "none",
    color: "#383838",
  },
  branchList: {
    width: "48%",
    borderRadius: "20px",
    boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
    height: "400px",
    overflowY: "scroll",
  },
  branchCard: {
    padding: "16px",
    marginBottom: "12px",
    borderBottom: "1px solid #C0C0C0",
    margin: "20px",
  },
  branchTitle: {
    fontSize: "18px",
    fontWeight: "bold",
    color: "#D31C4F",
  },
  branchText: {
    color: "#6b7280",
    margin: "4px 0",
  },
  footer: {
    backgroundColor: "#f3f4f6",
    padding: "16px",
    textAlign: "center",
  },
  footerLinks: {
    display: "flex",
    justifyContent: "center",
    gap: "16px",
    marginTop: "8px",
  },
  footerLink: {
    color: "#2563eb",
    textDecoration: "none",
    fontWeight: "bold",
  },
};
